module.exports = __webpack_public_path__ + "img/home.e719b432.png";